<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M6.28655 1.14258H0.572266V6.85686H6.28655V1.14258Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M15.144 15.4282H9.42969"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.42969 9.71436H15.144"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.42969 12.5713H15.144"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M15.4302 6.857H9.14453L12.2874 0.571289L15.4302 6.857Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M3.42941 15.4286C5.00736 15.4286 6.28655 14.1494 6.28655 12.5715C6.28655 10.9935 5.00736 9.71436 3.42941 9.71436C1.85145 9.71436 0.572266 10.9935 0.572266 12.5715C0.572266 14.1494 1.85145 15.4286 3.42941 15.4286Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
